export enum Statuses {
    INFO = 'blue',
    SUCCESS = 'green',
    WARN = 'yellow',
    ERROR = 'red',
    NEUTRAL = 'gray',
    LEGACY = 'magenta'
}
